import i18n from './i18n';
import config from './config';

let routes = {};

i18n.on('initialized', () => {
  routes = {
    en: {
      myFuture: config.baseUrl.en + '/' + i18n.t('local:route.myFuture', {lng: 'en'}),
      aboutJobs: '/',
      role: '/job-role',
      qualifications: '/qualifications',
      think: '/things-to-think-about',
      right: '/is-this-right-for-me'
    },
    cy: {
      myFuture: config.baseUrl.cy + '/' + i18n.t('local:route.myFuture', {lng: 'cy'}),
      aboutJobs: '/',
      role: '/rol-y-swydd',
      qualifications: '/cymwysterau',
      think: '/pethau-i-feddwl-amdanynt',
      right: '/a-ywr-swydd-yman-addas-i-mi'
    }
  }
});

export function route(name, parameters = null, language = i18n.language) {
  if (parameters) {
    return routes[language][name].split('/').map(fragment => {
       return fragment.startsWith(':') ? parameters[fragment.substr(1)] : fragment;
    }).join('/');
  }

  return routes[language][name];
}
